export const environment = {
  production: true,
  apiUrl: 'https://api.rh.purple.lk',
  recaptchaSiteKey: '6LfsGOQqAAAAAJNr2_nKYTMpoCnVFhBl1-6kM1jE',
};
